<template>
  <vs-row class="mb-3">
    <vs-col
      vs-order="1"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="3"
      class="px-0"
      v-show="page == 'dashboard'"
    >
      <v-date-picker
        v-model="selectedDate"
        mode="date"
        is-range
        :locale="$i18n.locale"
        :buddhist="true"
        :max-date="new Date()"
        class="cursor-pointer w-full"
      >
        <template v-slot="{ inputEvents }">
          <vs-button
            v-on="inputEvents.start"
            size="small"
            color="#6E6F70"
            class="w-full text-left cardDate"
          >
            <div class="vx-row">
              <div
                class="vx-col text-center mt-2 pl-5 sm:w-1/3 lg:w-1/3 xl:w-1/3"
              >
                <vs-icon color="#fff" size="medium" icon="today"></vs-icon>
              </div>
              <div class="vx-col center sm:w-2/3 lg:w-2/3 xl:w-2/3">
                <h6 class="text-white">{{ setFormat(selectedDate.start) }}</h6>
                <hr class="mx-2 my-1" />
                <h6 class="text-white">{{ setFormat(selectedDate.end) }}</h6>
              </div>
            </div>
          </vs-button>
        </template>
      </v-date-picker>
    </vs-col>
    <vs-col
      vs-order="2"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      :vs-w="page == 'dashboard' ? 3 : 4"
      class="px-1"
    >
      <vs-button color="#6E6F70" class="w-full h-16">จังหวัด</vs-button>
    </vs-col>
    <vs-col
      vs-order="3"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      :vs-w="page == 'dashboard' ? 3 : 4"
      class="px-1"
    >
      <vs-button color="#6E6F70" class="w-full h-16">กลุ่มเรือ</vs-button>
    </vs-col>
    <vs-col
      vs-order="3"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      :vs-w="page == 'dashboard' ? 3 : 4"
      class="px-1"
    >
      <vs-button color="#6E6F70" class="w-full h-16"
        >เรือบรรทุกน้ำมัน</vs-button
      >
    </vs-col>
  </vs-row>
</template>

<script>
import moment from "moment";
export default {
     props: {
    page: {
      type: String,
    },
  },
     data() {
    return {
       selectedDate: {
        start: new Date(),
        end: new Date(),
      },
    }
   },
   methods: {
      setFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date)
          .add(543, "years")
          .format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
   }
};
</script>

<style></style>
